import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { Box } from 'grommet'
import { BodyCopy, ContainedButton, HeaderTwo } from 'secondstep-components'

export const Wrapper = styled(Box)`
  align-items: center;
  width: 100%;
  padding: 2.8125rem 2.25rem 3.813rem;
  text-align: center;

  ${HeaderTwo} {
    padding: 1.25rem 1rem 1.4rem;
    text-align: center;
    color: ${themeGet('preferencesSetup.color')};
    font-family: ${themeGet('font.sharpSlab.semibold')};
    font-size: 1rem;
  }

  ${BodyCopy} {
    max-width: 500px;
    padding-bottom: 2rem;
    line-height: 1.375rem;
    color: ${themeGet('colors.darkGray')};
  }
`

export const CircleImage = styled.div`
  width: ${themeGet('preferencesSetup.width')};
  height: ${themeGet('preferencesSetup.height')};
  background-image: ${props =>
    props.imageUrl ? `url(${props.imageUrl})` : 'none'};
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const StyledContainedButton = styled(ContainedButton)`
  text-transform: none;
  min-width: 6.875rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  background-color: ${themeGet('colors.buttons.primaryPlaySession')};

  &:not([disabled]):hover {
    background-color: ${themeGet('colors.buttons.hoverPlaySession')};
  }
`
